module.exports = __webpack_public_path__ + "2b076b22ec5d93f396a8db3c03d7265a.fbx";